// extracted by mini-css-extract-plugin
module.exports = {"titleText":"e_lq","container":"e_mq","authorText":"e_nq","title":"e_oq","image":"e_pq","description":"e_qq","author":"e_rq","splitLine":"e_sq"};